import {
  avatar,
  background,
  captions,
  card,
  host,
  rule,
  speaker,
  text,
  visualizer,
} from './helpers'
import type { TemplateBlueprint } from './types'

/**
 * `FramedLayout` (`layouts/FramedLayout.tsx`): a card in the border colour
 * framed by the page; the speaker's name over mirrored bars on top, the
 * episode at the foot under a rule in the `logo` colour. One line each.
 * No intended differences beyond the shared ones (the v1 icon badge is the
 * watermark now).
 */
const bars = { variant: 'mirrored' as const }
const name = { size: 38, weight: 400, lineHeight: 1.2 }
const episode = { size: 34, weight: 400, lineHeight: 1.5 }

export const framedBlueprint: TemplateBlueprint = {
  kind: 'audio',
  orientations: {
    portrait: [
      background(),
      card('portrait', 'card', [86, 86, 908, 1748]),
      avatar('portrait', 172, 172, 194),
      speaker('portrait', [426, 201, 482, 46], 'name', name, {
        color: 'speakerName',
        surface: 'border',
      }),
      visualizer('portrait', [426, 276, 482, 60], bars, { surface: 'border' }),
      captions('portrait', [172, 366, 736, 1206], 'center', {
        surface: 'border',
      }),
      rule('portrait', 'divider', [172, 1572, 736, 2], 'logo'),
      host('portrait', 172, 1644, 104),
      text('portrait', 'title', [318, 1644, 590, 51], episode, {
        surface: 'border',
      }),
      text('portrait', 'subtitle', [318, 1695, 590, 51], episode, {
        surface: 'border',
      }),
    ],
    square: [
      background(),
      card('square', 'card', [86, 86, 908, 908]),
      avatar('square', 172, 172, 194),
      speaker('square', [426, 201, 482, 46], 'name', name, {
        color: 'speakerName',
        surface: 'border',
      }),
      visualizer('square', [426, 276, 482, 60], bars, { surface: 'border' }),
      captions('square', [172, 366, 736, 366], 'center', { surface: 'border' }),
      rule('square', 'divider', [172, 732, 736, 2], 'logo'),
      host('square', 172, 804, 104),
      text('square', 'title', [318, 804, 590, 51], episode, {
        surface: 'border',
      }),
      text('square', 'subtitle', [318, 855, 590, 51], episode, {
        surface: 'border',
      }),
    ],
    landscape: [
      background(),
      card('landscape', 'card', [86, 86, 1748, 908]),
      avatar('landscape', 172, 172, 194),
      speaker('landscape', [426, 201, 1000, 46], 'name', name, {
        color: 'speakerName',
        surface: 'border',
      }),
      visualizer('landscape', [426, 276, 500, 60], bars, {
        surface: 'border',
      }),
      captions('landscape', [172, 366, 1576, 380], 'center', {
        surface: 'border',
      }),
      rule('landscape', 'divider', [172, 746, 1576, 2], 'logo'),
      host('landscape', 172, 804, 104),
      text('landscape', 'title', [318, 804, 1430, 51], episode, {
        surface: 'border',
      }),
      text('landscape', 'subtitle', [318, 855, 1430, 51], episode, {
        surface: 'border',
      }),
    ],
  },
}
